import * as Sentry from '@sentry/react';

import { setupTrackers } from 'mf-shared/libs/clevertap';
import { setupClickStream } from '@ce-bo/common-app/lib/clickstream';

// =====================================================================
// Global setup
// These setup are common across all the apps. They are placed here first
// before we successfully splited the applications.
if (process.env.SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    normalizeDepth: 10,
    release: __MOKA_VERSION__,
    sampleRate: 0.25, // 25%
  });
}

setupTrackers();
setupClickStream();
